/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($id: ID!) {
    getUserInfo(id: $id) {
      id
      scraping
      trial
      email
      customerId
      stripeAccount
      stripeParentAccount
      createdAt
      updatedAt
      profile {
        id
        name
        phone
        address
        createdAt
        updatedAt
      }
      order {
        items {
          id
          userId
          amount
          metadata
          createdAt
          updatedAt
        }
        nextToken
      }
      shop {
        items {
          id
          userId
          shopId
          createdAt
          updatedAt
          shop {
            id
            name
            domain
            spider
            link
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      buyma {
        items {
          id
          userId
          kaiinId
          buyma
          accessCode
          endedAt
          approved
          subAccount
          createdAt
          updatedAt
        }
        nextToken
      }
      conf {
        id
        scraping
        buymanager
        image
        base
        createdAt
        updatedAt
      }
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos(
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        scraping
        trial
        email
        customerId
        stripeAccount
        stripeParentAccount
        createdAt
        updatedAt
        profile {
          id
          name
          phone
          address
          createdAt
          updatedAt
        }
        order {
          items {
            id
            userId
            amount
            metadata
            createdAt
            updatedAt
          }
          nextToken
        }
        shop {
          items {
            id
            userId
            shopId
            createdAt
            updatedAt
            shop {
              id
              name
              domain
              spider
              link
              createdAt
              updatedAt
              owner
            }
          }
          nextToken
        }
        buyma {
          items {
            id
            userId
            kaiinId
            buyma
            accessCode
            endedAt
            approved
            subAccount
            createdAt
            updatedAt
          }
          nextToken
        }
        conf {
          id
          scraping
          buymanager
          image
          base
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listUserInfosBySpecificStripeParentAccount = /* GraphQL */ `
  query ListUserInfosBySpecificStripeParentAccount(
    $stripeParentAccount: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInfosBySpecificStripeParentAccount(
      stripeParentAccount: $stripeParentAccount
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scraping
        trial
        email
        customerId
        stripeAccount
        stripeParentAccount
        createdAt
        updatedAt
        profile {
          id
          name
          phone
          address
          createdAt
          updatedAt
        }
        order {
          items {
            id
            userId
            amount
            metadata
            createdAt
            updatedAt
          }
          nextToken
        }
        shop {
          items {
            id
            userId
            shopId
            createdAt
            updatedAt
            shop {
              id
              name
              domain
              spider
              link
              createdAt
              updatedAt
              owner
            }
          }
          nextToken
        }
        buyma {
          items {
            id
            userId
            kaiinId
            buyma
            accessCode
            endedAt
            approved
            subAccount
            createdAt
            updatedAt
          }
          nextToken
        }
        conf {
          id
          scraping
          buymanager
          image
          base
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getProfile = /* GraphQL */ `
  query GetProfile($id: ID!) {
    getProfile(id: $id) {
      id
      name
      phone
      address
      createdAt
      updatedAt
    }
  }
`;
export const listProfiles = /* GraphQL */ `
  query ListProfiles(
    $filter: ModelProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        phone
        address
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      userId
      amount
      metadata
      createdAt
      updatedAt
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        amount
        metadata
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserShop = /* GraphQL */ `
  query GetUserShop($id: ID!) {
    getUserShop(id: $id) {
      id
      userId
      shopId
      createdAt
      updatedAt
      shop {
        id
        name
        domain
        spider
        link
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const listUserShops = /* GraphQL */ `
  query ListUserShops(
    $filter: ModelUserShopFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserShops(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        shopId
        createdAt
        updatedAt
        shop {
          id
          name
          domain
          spider
          link
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const getUserBuyma = /* GraphQL */ `
  query GetUserBuyma($id: ID!) {
    getUserBuyma(id: $id) {
      id
      userId
      kaiinId
      buyma
      accessCode
      endedAt
      approved
      subAccount
      createdAt
      updatedAt
    }
  }
`;
export const listUserBuymas = /* GraphQL */ `
  query ListUserBuymas(
    $filter: ModelUserBuymaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserBuymas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        kaiinId
        buyma
        accessCode
        endedAt
        approved
        subAccount
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserConf = /* GraphQL */ `
  query GetUserConf($id: ID!) {
    getUserConf(id: $id) {
      id
      scraping
      buymanager
      image
      base
      createdAt
      updatedAt
    }
  }
`;
export const listUserConfs = /* GraphQL */ `
  query ListUserConfs(
    $filter: ModelUserConfFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserConfs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        scraping
        buymanager
        image
        base
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShop = /* GraphQL */ `
  query GetShop($id: ID!) {
    getShop(id: $id) {
      id
      name
      domain
      spider
      link
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listShops = /* GraphQL */ `
  query ListShops(
    $id: ID
    $filter: ModelShopFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShops(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        domain
        spider
        link
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getBrand = /* GraphQL */ `
  query GetBrand($id: ID!) {
    getBrand(id: $id) {
      id
      brand
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listBrands = /* GraphQL */ `
  query ListBrands(
    $filter: ModelBrandFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBrands(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        brand
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      name
      sex
      important
      normal
      japanese
      foreign
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listCategorys = /* GraphQL */ `
  query ListCategorys(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        sex
        important
        normal
        japanese
        foreign
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getColor = /* GraphQL */ `
  query GetColor($id: ID!) {
    getColor(id: $id) {
      id
      name
      key
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listColors = /* GraphQL */ `
  query ListColors(
    $filter: ModelColorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listColors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        key
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getTranslateApi = /* GraphQL */ `
  query GetTranslateApi($id: ID!) {
    getTranslateApi(id: $id) {
      id
      translate
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listTranslateApis = /* GraphQL */ `
  query ListTranslateApis(
    $filter: ModelTranslateApiFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTranslateApis(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        translate
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getExhibition = /* GraphQL */ `
  query GetExhibition($id: ID!) {
    getExhibition(id: $id) {
      id
      kaiinId
      url
      imgFolder
      size
      currency
      vatoff
      deliPrice
      profit
      duty
      vipLate
      noCurPrice
      sellPrice
      syuppin
      change
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listExhibitions = /* GraphQL */ `
  query ListExhibitions(
    $filter: ModelExhibitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExhibitions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        kaiinId
        url
        imgFolder
        size
        currency
        vatoff
        deliPrice
        profit
        duty
        vipLate
        noCurPrice
        sellPrice
        syuppin
        change
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const listExhibitionsBySpecificKaiinId = /* GraphQL */ `
  query ListExhibitionsBySpecificKaiinId(
    $kaiinId: Int
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelExhibitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExhibitionsBySpecificKaiinId(
      kaiinId: $kaiinId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        kaiinId
        url
        imgFolder
        size
        currency
        vatoff
        deliPrice
        profit
        duty
        vipLate
        noCurPrice
        sellPrice
        syuppin
        change
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
